<template>
<v-container grid-list-xl text-xs-center>
  <v-layout v-if="pageLoading">
    <v-flex>
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-flex>
  </v-layout>
  <v-layout row v-else>
    <v-flex xs12 v-show="not_found">
      <v-alert
        :value="true"
        type="info"
      >
        No hay ninguna asamblea disponible para tomar asistencia.
      </v-alert>
    </v-flex>
    <v-flex v-show="!assemblyIsClosed && !not_found" xs12 sm5 md8 offset-xs0 >
      <v-layout row>
        <v-flex xs 12>
        <v-btn large color="primary" @click="qr_dialog = true">
          Leer QR
        </v-btn>
          <div class="headline">
            Toma de asistencia asamblea {{ assemblyData.description }} {{ assemblyData.assembly_date && assemblyData.assembly_date.split('-')[0] }}
          </div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-checkbox
            v-model="familySentAgent"
            color="primary"
            label="Asistencia con poder"
            @mouseup="signatureIsActive = false"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm8 md8>

          <v-autocomplete
            v-model="currentFamilySearch"
            :items="familyResult"
            :loading="isLoading"
            :search-input.sync="searchFamily"
            color="primary"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="name"
            :placeholder="familySentAgent ? 'Buscar familia poderdante' : 'Buscar familia'"
            return-object
            clearable
            :error="inputSearchError"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 sm4 md4>
          <v-btn :loading="validatingFamily" :disabled="!currentFamilySearch" v-show="!familySentAgent" @click="handlesignature(1)" large color="primary">Firmar Asamblea</v-btn>
        </v-flex>
      </v-layout>
      <v-flex v-show="parents.asopaf === 0 || parents.asopaf === 1" xs12 md8 sm8>
        <div class="family_info">
          <span class="asopaf_mark">
            <v-alert
              :value="true"
              :color="this.parents.asopaf === 1 ? 'error' : 'info'"
              outline
            >
              <b>ASOPAF:</b> {{ this.parents.asopaf === 1 ? 'Si' : 'No' }}
            </v-alert>
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>Padre:</b> {{ this.parents.father }}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>Madre:</b> {{ this.parents.mother }}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b v-if="currentFamilySearch" >Código: {{ currentFamilySearch.id}} </b> 
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b v-if="currentFamilySearch" ># Representados:  {{ this.parents.powers_number  }}</b> 
        </div>
      </v-flex>
      <v-layout row>
        <v-flex v-show="familySentAgent" xs12 sm8 md8>
          <v-autocomplete
            v-model="currentFamilySearch1"
            :items="familyResult1"
            :loading="isLoading1"
            :search-input.sync="searchFamily1"
            color="primary"
            hide-no-data
            hide-selected
            item-text="name"
            item-value="name"
            placeholder="Buscar familia apoderada"
            return-object
            clearable
            :error="inputSearchError1"
          ></v-autocomplete>
        </v-flex>
        <v-flex v-show="familySentAgent" xs12 sm4 md4>
          <v-btn :loading="validatingFamily" :disabled="!currentFamilySearch1" @click="handlesignature(2)" large color="primary">Firmar Asamblea</v-btn>
        </v-flex>
      </v-layout>
      <v-flex v-show="(parentsAgent.asopaf === 1 || parentsAgent.asopaf === 0) && familySentAgent" xs12 md8 sm8>
        <div class="family_info">
          <span class="asopaf_mark">
            <v-alert
              :value="true"
              :color="this.parentsAgent.asopaf === 1 ? 'error' : 'info'"
              outline
            >
              <b>ASOPAF:</b> {{ this.parentsAgent.asopaf === 1 ? 'Si' : 'No' }}
            </v-alert>
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>Padre:</b> {{ this.parentsAgent.father }}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <b>Madre:</b> {{ this.parentsAgent.mother }}
        </div>
      </v-flex>
      <v-flex v-show="signatureIsActive" xs12 md8 sm8>
        <v-checkbox
            v-model="physicalSignature"
            color="primary"
            label="Firmar asamblea en físico"
          ></v-checkbox>
      </v-flex>
      <v-flex v-show="physicalSignature" xs12 md8 sm8>
        <v-text-field
          v-model="notes"
          name="notes"
          placeholder="Observaciones"
          :error-messages="notes_error"
          :counter="100"
        ></v-text-field>
        <v-btn medium @click="save" color="primary">Guardar</v-btn>
      </v-flex>
      <v-layout v-show="familyHasError" row>
        <v-flex xs12 sm8 md8>
          <v-alert
            :value="true"
            type="warning"
          >
            {{familyErrorMessage}}
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout v-show="agentHasError" row>
        <v-flex xs12 sm8 md8>
          <v-alert
            :value="true"
            type="warning"
          >
            {{agentErrorMessage}}
          </v-alert>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex v-show="!not_found" xs12 sm5 md4>
      <v-card elevation-10>
          <v-card-title class="subheading font-weight-bold primary white--text">{{ assemblyData.description }}</v-card-title>

          <v-divider></v-divider>

          <v-list dense>
            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Fecha asamblea:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ assemblyData.assembly_date }}</v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Hora de inicio:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ assemblyData.assembly_time }}</v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Responsable:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ assemblyData.responsible_name }}</v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Número de poderes:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ assemblyData.delegated_powers_limit }}</v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Asistencia mínima:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ assemblyData.min_attendance_percentage }} %</v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Asistencia actual:</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">{{ this.actualPercent }} %</v-list-tile-content>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">%Quorum</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">
                  {{ quorum }}%
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content class="font-weight-bold">Quorum</v-list-tile-content>
              <v-list-tile-content class="align-end-assistance">
                  <span class="green--text font-weight-bold" v-if="quorum >= 100">Si</span>
                  <span class="red--text font-weight-bold" v-else>No</span>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-card-actions v-show="!fromMenu">
            <v-btn v-if="!assemblyIsClosed" medium @click="closeAssemblyConfirm = true" color="warning">Cerrar asamblea</v-btn>
            <v-alert
              v-else
              :value="true"
              color="warning"
            >
              Esta asamblea esta cerrada
            </v-alert>
          </v-card-actions>
        </v-card>
    </v-flex>
  </v-layout>
  <v-layout v-if="signatureIsActive && !physicalSignature" row>
    <v-flex xs12 sm12 md12>
      <v-card>
        <v-card-title class="primary font-weight-bold white--text">Firma:</v-card-title>
        <VueSignaturePad
          ref="signaturePad"
        />
        <v-card-actions>
          <v-btn medium @click="save" color="primary">Guardar</v-btn>
          <v-btn medium @click="undo" >Deshacer</v-btn>
          <v-btn medium @click="clear" >Limpiar</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  <v-dialog
      v-model="closeAssemblyConfirm"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">Esta seguro ?</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="closeAssemblyConfirm = false"
          >
            No
          </v-btn>

          <v-btn
            color="orange darken-1"
            flat="flat"
            @click="closeAssembly"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="qr_dialog"
      transition="dialog-transition"
      max-width="1280px"
      overlay-color="white"
    >
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="qr_dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Tomar asistencia con código QR</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-toolbar>
      <QrReader v-if="idAssembly"
        :idAssembly="this.idAssembly"
      ></QrReader>
    </v-dialog>
</v-container>
</template>
<script>
import axios from 'axios';
import QrReader from '~/pages/assembly/qr_reader'

export default {
  name: 'assembly-assistance-view',
  components: {
    QrReader
  },
  data() {
    return {
      idAssembly: '',
      assemblyData: {},
      userNameMaxLength: 60,
      entries: [],
      isLoading: false,
      currentFamilySearch: null,
      searchFamily: null,
      inputSearchError: false,
      entries1: [],
      isLoading1: false,
      currentFamilySearch1: null,
      searchFamily1: null,
      inputSearchError1: false,
      familySentAgent: false,
      signatureIsActive: false,
      familyCode: '',
      agentCode: '',
      familyHasError: '',
      familyErrorMessage: '',
      agentHasError: '',
      agentErrorMessage: '',
      closeAssemblyConfirm: false,
      assemblyIsClosed: true,
      actualPercent: 0,
      quorum: 0,
      physicalSignature: false,
      fromMenu: false,
      notes: '',
      pageLoading: true,
      validatingFamily: false,
      powers_number: null,
      parents: {},
      parentsAgent: {},
      not_found: false,
      notes_error: '',
      qr_dialog: false,
    }
  },
  created() {
    const idAssembly = this.$route.params.id;
    if (!idAssembly) {
      axios.get('/api/assembly/next/assistance')
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            if (data.not_found) {
              this.pageLoading = false;
              this.not_found = true;
              return;
            }
            this.assemblyData = data.assembly;
            this.actualPercent = data.actual_percent;
            this.quorum = data.quorum;
            this.idAssembly = response.data.assembly.id;
            if (data.assembly.status == 0 || data.assembly.status == "0") {
              this.assemblyIsClosed = false;
            }
            this.fromMenu = true;
          }
          this.pageLoading = false;
        })
        .catch(error => {
          this.pageLoading = false;
          console.log(error);
        })
    } else {
      this.idAssembly = idAssembly;
      axios.get(`/api/assembly/${idAssembly}`)
        .then(response => {
          const { data, status } = response;
          if (status === 200) {
            this.assemblyData = data.assembly;
            this.actualPercent = data.actual_percent;
            this.quorum = data.quorum;
            if (data.assembly.status == 0 || data.assembly.status == "0") {
              this.assemblyIsClosed = false;
            }
          }
          this.pageLoading = false;
        })
        .catch(error => {
          this.pageLoading = false;
          console.log(error);
        });
    }
  },
  methods: {
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    save() {
      let isEmpty, data;

      if (!this.physicalSignature) {
        isEmpty = this.$refs.signaturePad.saveSignature().isEmpty;
        data = this.$refs.signaturePad.saveSignature().data;
      }

      if (isEmpty && !this.physicalSignature) {
        return;
      }

      if (this.physicalSignature && (!this.notes || this.notes.trim() === '')) {
        this.notes_error = 'Este campo es requerido.';
        return;
      }

      if (this.physicalSignature && this.notes.length > 100) {
        this.notes_error = 'Este campo no puede tener mas de 100 caracteres.';
        return;
      }

      const payload = {
        id_assembly: this.idAssembly,
        family_code: this.familyCode,
        agent: this.familySentAgent ? 1 : 0,
        agent_code: this.familySentAgent ? this.agentCode : '',
        signature: this.physicalSignature ? '' : data,
        physical_signature: this.physicalSignature ? 1 : 0,
        notes: this.notes
      };

      axios.post('/api/assembly/assistance', payload)
        .then(response => {
          if (response.status === 200) {
            if (!this.physicalSignature) {
              this.$refs.signaturePad.clearSignature();
            }
            this.agentCode = "";
            this.familyCode = "";
            this.currentFamilySearch = null;
            this.currentFamilySearch1 = null;
            this.familySentAgent = false;
            this.signatureIsActive = false;
            this.actualPercent = response.data.actual_percent;
            this.quorum = response.data.quorum;
            this.physicalSignature = false;
            this.parents = {};
            this.notes_error = '';
            this.notes = '';
          }
        })
        .catch(error => {
          console.log(error);
        });

    },
    async handlesignature(button) {
      let signatureIsActive = true;
      this.familyHasError = false;
      this.familyErrorMessage = "";
      this.inputSearchError = false;
      this.inputSearchError1 = false;
      this.validatingFamily = true;
      if (!this.currentFamilySearch) {
        this.inputSearchError = true;
        this.validatingFamily = false;
        return;
      }
      if (this.familySentAgent && !this.currentFamilySearch1) {
        this.inputSearchError1 = true;
        this.validatingFamily = false;
        return;
      }
      if (button === 1) {
        await axios.get(`/api/assembly/validate/family/${this.currentFamilySearch.id}`)
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              if (!data.valid_assistance) {
                this.familyHasError = true;
                this.familyErrorMessage = data.message;
                signatureIsActive = false;
              }
            }
            this.validatingFamily = false;
          })
          .catch(error => {
            signatureIsActive = false;
            console.log(error);
            this.validatingFamily = false;
          });
      }

      if (button === 2) {
        await axios.get(`/api/assembly/validate/family/${this.currentFamilySearch.id}`)
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              if (!data.valid_assistance) {
                this.familyHasError = true;
                this.familyErrorMessage = data.message;
                signatureIsActive = false;
              }
            }
            this.validatingFamily = false;
          })
          .catch(error => {
            signatureIsActive = false;
            console.log(error);
            this.validatingFamily = false;
          });

        await axios.get(`/api/assembly/validate/family_agent/${this.currentFamilySearch1.id}/${this.idAssembly}`)
          .then(response => {
            const { status, data } = response;
            if (status === 200) {
              // if (this.parents.asopaf === 1) {
              //   if (!data.asopaf) {
              //       this.agentHasError = true;
              //       this.agentErrorMessage = "Familia poderdante en ASOPAF, familia apoderada también debe ser de ASOPAF."
              //       signatureIsActive = false;
              //       return;
              //   }
              // }
              if (data.employee) {
                this.agentHasError = true;
                this.agentErrorMessage = "Familia es empleado, no puede administrar poderes."
                signatureIsActive = false;
                return;
              }
              if (data.board_member > 0) {
                this.agentHasError = true;
                this.agentErrorMessage = "Familia es miembro de junta, no puede administrar poderes."
                signatureIsActive = false;
                return;
              }
              if (data.agent_assistance === 0) {
                this.agentHasError = true;
                this.agentErrorMessage = "Familia aún no ha firmado asistencia, no puede utilizar poderes."
                signatureIsActive = false;
                return;
              }
              if (data.powers_number >= this.assemblyData.delegated_powers_limit) {
                this.agentHasError = true;
                this.agentErrorMessage = "Ha superado el número de poderes permitido."
                signatureIsActive = false;
              }
            }
            this.validatingFamily = false;
          })
          .catch(error => {
            signatureIsActive = false;
            console.log(error);
            this.validatingFamily = false;
          });
      }


      this.familyCode = this.currentFamilySearch.id;
      if (this.familySentAgent) {
        this.agentCode = this.currentFamilySearch1.id;
      }

      this.signatureIsActive = signatureIsActive;

    },
    closeAssembly() {
      const idAssembly = this.idAssembly;
      axios.post('/api/assembly/close', { idAssembly })
        .then(response => {
          if (response.status === 200) {
            this.assemblyIsClosed = true;
            this.closeAssemblyConfirm = false;
          }
        })
        .catch(error => {
          console.log(error);
        })
    }
  },
  computed: {
    familyResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    },
    familyResult1() {
      return this.entries1.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + '...'
          : user.name

        return Object.assign({}, user)
      })
    }
  },

  watch: {
    searchFamily(val) {
      this.familyHasError = false;
      this.familyErrorMessage = "";
      this.signatureIsActive = false;
      this.parents = {};
      this.physicalSignature = false;
      if (!val) {
        this.isLoading = false
        return
      }

      if (this.isLoading) return

      this.isLoading = true

      axios.get(`/api/assembly/search_family/${val}/${this.idAssembly}`)
        .then(res => {
          const { data } = res
          this.count = data.length;
          this.entries = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },
    searchFamily1(val) {
      this.agentHasError = false;
      this.agentErrorMessage = "";
      this.signatureIsActive = false;
      this.physicalSignature = false;
      this.parentsAgent = {};
      if (!val) {
        this.isLoading1 = false
        return
      }
      if (this.isLoading1) return

      this.isLoading1 = true

      axios.get(`/api/assembly/search_agent/${val}/${this.idAssembly}`)
        .then(res => {
          const { data } = res
          this.count1 = data.length;
          this.entries1 = data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading1 = false))
    },
    familySentAgent: function() {
      this.agentHasError = false;
      this.agentErrorMessage = '';
      this.familyHasError = false;
      this.familyErrorMessage = '';
    },
    currentFamilySearch: function(newVal, oldVal) {
      if (newVal) {
        axios.get(`/api/family/parents/${newVal.id}/${this.assemblyData.id}`)
          .then(res => {
            if (res.status === 200) {
              this.parents = res.data;
            }
          })
          .catch(error => console.log(error));
          return;
      }
      this.parents = {};
    },
    currentFamilySearch1: function(newVal, oldVal) {
      if (newVal) {
        axios.get(`/api/family/parents/${newVal.id}`)
          .then(res => {
            if (res.status === 200) {
              this.parentsAgent = res.data;
            }
          })
          .catch(error => console.log(error));
          return;
      }
      this.parentsAgent = {};
    }
  }
}
</script>
<style>
.align-end-assistance {
  align-items: flex-end !important;
}
.align-center-assistance {
  align-items: center !important;
}
.family_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/assistance.vue